import axios from 'axios';
import type { OfferSettingsJsonType } from '@bb/domain/dist/types';

export type OfferDetailsType = {
  offerCount: number;
  offerSettings: Pick<
    OfferSettingsJsonType,
    | 'acceptedAnytime'
    | 'offerDate'
    | 'otherInstructions'
    | 'preemptive'
    | 'registration'
    | 'requestIrrevocable'
  >;
  offerSubmissions: string;
};

const getOfferDetails = async (listingId: string) => {
  const { data: fetchedOfferDetails } = await axios.get<OfferDetailsType>(
    `/listing/${listingId}/offer_details`,
  );
  return fetchedOfferDetails;
};

export default getOfferDetails;
